export default "__VITE_ASSET__4189f9cb__"